import { roundClamp, toDegrees } from '../../platform/geom/Math';

const normalizeAngle = (angle: number = 0) => {
    angle = roundClamp(toDegrees(angle), 5);
    if (angle > 180) angle -= 360;
    if (angle < -180) angle += 360;
    return angle;
};

export const computeRotateCursor = (angle: number = 0) => `rotate-${normalizeAngle(angle)}`;
export const computeScaleCursor = (angle: number = 0) => `scale-${normalizeAngle(angle)}`;
